import * as React from 'react';
import { ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface FilterButtonProps {
  label: string;
  isActive?: boolean;
  disabled?: boolean;
  onClick: () => void;
  className?: string;
  selectedCount?: number;
}

export const FilterButton = React.forwardRef<HTMLButtonElement, FilterButtonProps>(
  ({ label, isActive, disabled, onClick, className, selectedCount }, ref) => {
    return (
      <Button
        ref={ref}
        variant="outline"
        size="sm"
        disabled={disabled}
        onClick={onClick}
        className={cn(
          'h-9 border-border/30 bg-background hover:bg-background hover:border-border/60 gap-1.5',
          isActive && 'border-border/60 bg-background',
          className
        )}
      >
        <span>{label}</span>
        <ChevronDown className="h-4 w-4 opacity-70" />
        {selectedCount ? (
          <span className="ml-1 text-xs font-medium text-foreground/60">{selectedCount}</span>
        ) : null}
      </Button>
    );
  }
);

FilterButton.displayName = 'FilterButton';
